import Vue from 'vue';
import axios from 'axios';
import VueCookies from 'vue-cookies';
import VueGtag from 'vue-gtag';
import VueGtm from 'vue-gtm';
import VueCurrencyInput from 'vue-currency-input';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import Multiselect from 'vue-multiselect';
import VCalendar from 'v-calendar';
import { asset } from '@codinglabs/laravel-asset';
import {
  capitalize,
  formatDateFilter,
  formatDateRange,
  awsImageUrl,
} from './helpers';
import router from './router';
import store from './store/index';
import App from './App.vue';
import './filters';
import CustomSearchField from './components/CustomSearchField.vue';
import ErrorAlert from './components/ErrorAlert.vue';
import CheckboxButton from './components/CheckboxButton';
import CustomDatePicker from './components/CustomDatePicker';
import PaginationHandler from './components/PaginationHandler';

window.Vue = require('vue').default;

// Package configurations
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueCookies);
Vue.use(VCalendar);
Vue.use(VueCurrencyInput, {
  globalOptions: {
    currency: 'USD',
    locale: 'en-US',
    valueAsInteger: true,
    allowNegative: false,
    distractionFree: false,
  },
});

// Google gtag init
Vue.use(VueGtag, {
  config: { id: process.env.MIX_GOOGLE_ANALYTICS_ID },
});

// Google tag manager init
Vue.use(VueGtm, {
  id: process.env.MIX_GOOGLE_TAG_MANAGER_ID,
  defer: true,
  vueRouter: router,
});

// Global components
Vue.component('CustomSearchField', CustomSearchField);
Vue.component('ErrorAlert', ErrorAlert);
Vue.component('CheckboxButton', CheckboxButton);
Vue.component('CustomDatePicker', CustomDatePicker);
Vue.component('PaginationHandler', PaginationHandler);
Vue.component('Multiselect', Multiselect);

// Configure axios default configs
axios.defaults.baseURL = `${process.env.MIX_ZDM_API_HOST}/api/v1/`;
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common.Accept = 'application/json';
if ($cookies.isKey('zdm_authentication')) {
  axios.defaults.headers.common.Authorization = `Bearer ${$cookies.get(
    'zdm_authentication'
  )}`;
}
axios.interceptors.request.use((request) => {
  if (request.params) {
    const keys = Object.keys(request.params);
    const changedParams = {};

    for (let i = 0; i < keys.length; i += 1) {
      if (keys[i] === 'filters' && request.params[keys[i]]) {
        changedParams[keys[i]] = JSON.stringify(request.params[keys[i]]);
      } else if (
        ['start', 'startDate', 'end', 'endDate'].includes(keys[i]) &&
        request.params[keys[i]]
      ) {
        // Add timezone
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (timezone) {
          changedParams[keys[i]] = `${request.params[keys[i]]}:${timezone}`;
        } else {
          changedParams[keys[i]] = request.params[keys[i]];
        }
      } else if (
        request.params[keys[i]] ||
        request.params[keys[i]] === false ||
        request.params[keys[i]] === 0
      ) {
        changedParams[keys[i]] = request.params[keys[i]];
      }
    }
    request.params = changedParams;
  }

  return request;
});

// Global mixins
Vue.mixin({
  methods: {
    asset,
    capitalize,
    formatDateFilter,
    formatDateRange,
    awsImageUrl,
  },
});

new Vue({
  router,
  store,
  created() {
    this.$store.dispatch('session/load');
  },
  render: (h) => h(App),
}).$mount('#App');
